import { render, staticRenderFns } from "./VFormItemPhones.vue?vue&type=template&id=10d89d84&"
import script from "./VFormItemPhones.vue?vue&type=script&lang=js&"
export * from "./VFormItemPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports